
import { IconBankIdent24 } from '@fabric-ds/icons/react';
import React from "react";

export interface IProps {
  verified: boolean
}

const Verified: React.FunctionComponent<IProps> = (props) => {
  if (!props.verified) {
    return null;
  }
  return <div className='flex items-center'>
      <IconBankIdent24 className='w-16 h-16 text-white inline-block mr-2' style={{ fill: '#0063FB'}} />
      <p className='text-14 leading-18 m-0 pt-2'>Verifisert med BankID</p>
    </div>
};

export default Verified;

